import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { Container, Row, Col, Form, Button, Modal } from 'react-bootstrap'
import toast from 'react-hot-toast'
import * as XLSX from 'xlsx' // Import xlsx library
import Cookies from 'js-cookie'
import { useNavigate } from 'react-router-dom'
import { theme } from '../theme/theme'
import { BASE_URL } from '../constants'
import CustomBtn from '../common/CustomBtn'


const Plot = ({ onPlotCreated }) => {
  const [plot, setPlot] = useState({
    site_id: '', // Initially, no site is selected
    file: null, // No file selected initially
    plot_number: '',
    plot_size: '',
    price: '',
    status: '',
    block: '',
    is_corner: '',
  })

  const [siteNames, setSiteNames] = useState([])
  const [showModal, setShowModal] = useState(false)
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  const navigate = useNavigate()
  useEffect(() => {
    // Check for authentication token
    const token = Cookies.get('authToken')
    if (!token) {
      // If token is not found, redirect to login page
      window.location.href = '/login'
    }
  }, [])

  // Fetch the list of site names from the server when the component mounts
  useEffect(() => {
    const fetchSites = async () => {
      try {
        const response = await axios.get(
          BASE_URL+'/sites',
          {
            headers: {
              Authorization: `Bearer ${Cookies.get('authToken')}`, // Pass the token
            },
          },
        )
        setSiteNames(response.data.data) // Assuming the response contains a 'data' array
      } catch (err) {
        toast.error('Failed to fetch site names')
      }
    }

    fetchSites()
  }, [])

  // Handle site selection
  const handleSiteSelect = (e) => {
    const selectedSiteId = Number(e.target.value) // Get the selected site ID
    setPlot((prevPlot) => ({
      ...prevPlot,
      site_id: selectedSiteId, // Update the selected site ID in the state
    }))
  }

  const handleModalClose = () => {
    setShowModal(false)
  }
  // Handle file upload and parsing Excel data
  const fileHandler = (e) => {
    const file = e.target.files[0] // Get the file

    // Read the Excel file
    const reader = new FileReader()
    reader.onload = (event) => {
      const data = new Uint8Array(event.target.result)
      const workbook = XLSX.read(data, { type: 'array' })
      const firstSheetName = workbook.SheetNames[0]
      const worksheet = workbook.Sheets[firstSheetName]

      // Convert the worksheet to JSON
      const jsonData = XLSX.utils.sheet_to_json(worksheet)

      // Assuming your Excel has these columns
      if (jsonData.length > 0) {
        const plotData = jsonData[0] // Use the first row of the sheet

        // Validate and set data
        const allowedStatuses = ['SOLD', 'AVAILABLE', 'NOT AVAILABLE'] // Allowed status values
        const allowedIsCorner = ['YES', 'NO'] // Allowed is_corner values

        const status = allowedStatuses.includes(plotData.status)
          ? plotData.status
          : 'AVAILABLE' // Default to AVAILABLE if invalid

        const is_corner = allowedIsCorner.includes(plotData.is_corner)
          ? plotData.is_corner
          : 'NO' // Default to NO if invalid

        setPlot((prevPlot) => ({
          ...prevPlot,
          file, // Set the file
          plot_number: plotData.plot_number || '', // Fallback to empty string if not present
          plot_size: plotData.plot_size || '', // Fallback to empty string if not present
          price: plotData.price || '', // Fallback to empty string if not present
          status, // Use the validated status
          block: plotData.block || '', // Fallback to empty string if not present
          is_corner: is_corner, // Use the validated is_corner value
        }))
      } else {
        toast.error('No data found in the Excel file')
      }
    }
    reader.readAsArrayBuffer(file)
  }

  // Handle form submission
  const submitForm = async (e) => {
    e.preventDefault()

    setError('')
    setLoading(true)

    const token = Cookies.get('authToken') // Retrieve token from cookies

    // Validation before sending the form data
    if (!plot.site_id) {
      toast.error('Please select a site before submitting')
      return
    }

    if (!plot.file) {
      toast.error('Please upload a plot file before submitting')
      return
    }

    const formData = new FormData()
    formData.append('site_id', plot.site_id)
    formData.append('file', plot.file)
    // Append other plot data
    formData.append('plot_number', plot.plot_number)
    formData.append('plot_size', plot.plot_size)
    formData.append('price', plot.price)
    formData.append('status', plot.status)
    formData.append('block', plot.block)
    formData.append('is_corner', plot.is_corner)

    try {
      const response = await axios.post(
        BASE_URL+'/plot/create',
        formData,

        {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${token}`,
          },
        },
      )

      setShowModal(true)
      setTimeout(() => {
        navigate('/plotlists')
        window.location.reload()
      }, 3000)

      if (response.status === 200 || response.status === 201) {
        // toast.success(' New plot uploaded successfully')
        onPlotCreated(response.data.plot) // Trigger callback after successful upload
      } else {
        toast.error('Unexpected response from the server')
      }
    } catch (err) {
      toast.error(
        err.response?.data.message ||
          'Failed to upload plot. Please try again.',
      )
    }
  }


  const handleSampleExcelSheetDownload = ()=>{
    // yet to do
  }

  return (
      <Container className="pb-3" style={{fontFamily: theme.font.family }}>
      <Form className="text-start p-3 pb-3" onSubmit={submitForm} style={{backgroundColor: theme.colors.background}}>

        <p
                  className="mb-4 fw-bold"
                  style={{
                    color: theme.colors.primary,
                    borderBottom: `2px solid ${theme.colors.primary}`,
                    paddingBottom: '8px',
                    
                    fontSize: '1.5rem',
                  }}
                >
          Upload New Plot
                    
        </p>
        <div className='d-flex my-2 align-items-center justify-content-end' >
            <a href="/sample/sample_excel_sheet_format.csv" style={{textDecoration: 'none' , color: theme.colors.primary , padding: "2px 5px", backgroundColor : `${theme.colors.secondary}10`, border: `1px solid ${theme.colors.primary}`, borderRadius: '5px'}} download>
             Download Sample Excel Sheet Format
             <i class="fa-solid fa-download" style={{marginLeft: "1rem"}}></i>
            </a>

        </div>

        <Row>
          <Col md={6} className="mb-3">
            <Form.Label htmlFor="site_name">
              Site Name
              <span style={{ fontSize: '1.25rem', marginLeft: '0.25rem' }}>
                *
              </span>
            </Form.Label>
            <Form.Select
              id="site_name"
              name="site_name"
              onChange={handleSiteSelect}
              value={plot.site_id}
              required
            >
              <option value="">SELECT</option>
              {siteNames.map((site) => (
                <option key={site.id} value={site.id}>
                  {site.name}
                </option>
              ))}
            </Form.Select>
          </Col>

          {/* Upload Plot File */}
          <Col xs={12} md={6} className="mb-3">
            <Form.Label htmlFor="file">
              Upload Plot File (Excel)
              <span style={{ fontSize: '1.25rem', marginLeft: '0.25rem' }}>
                *
              </span>
            </Form.Label>
            <Form.Control
              type="file"
              id="file"
              name="file"
              onChange={fileHandler}
              accept=".xlsx, .xls" // Restrict file types to Excel
              required
            />
          </Col>
        </Row>
        {error && <div className="alert alert-danger">{error}</div>}
        <div className="d-grid mt-4 ">
          <Button
            type="submit"
                className="px-5 py-2 fw-semibold"
                style={{
                  backgroundColor: theme.colors.primary,
                  border: 'none',
                  color: '#fff',
                  width: '100%',
                }}
            disabled={loading}
          >
            {loading ? 'Uploading...' : 'Upload New Plot'}
          </Button>
        </div>
      </Form>
      <Modal show={showModal} onHide={handleModalClose} centered>
        <Modal.Header  closeButton>
          <Modal.Title className="w-100 text-center">
            Plot uploaded successfully!
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            The new plot has been added to the system successfully. You can now
            view their details or proceed with the next steps in the process.
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button style={{backgroundColor: theme.colors.error , border: 'none', color: theme.colors.background}} onClick={handleModalClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  )
}

export default Plot
